export const appName = "Sladká dílna";
